// NPM Imports
// import { EditorState } from "draft-js";

// Reducer Method
export default (
  state = {
    highlightedContent: null,
    // New keys
    lastEditorChangeTime: null,
    activeEditorState: null,
    activeComponent: null,
    activeComponentInfo: null,
    forceUpdateEditorConfigs: null,
    activeClauseOptionValueId: null,
  },
  action,
) => {
  switch (action.type) {
    // New Actions
    case "INIT_ACTIVE_EDITOR":
      return {
        ...state,
        activeEditorState: action.payload.activeEditorState,
        activeComponent: action.payload.activeComponent,
        activeComponentInfo: action.payload.activeComponentInfo,
        lastEditorChangeTime: {
          timeStamp: Date.now(),
          componentInfo: action.payload.activeComponentInfo,
        },
        activeClauseOptionValueId: action.payload.activeClauseOptionValueId,
      };

    case "UPDATE_ACTIVE_EDITOR_STATE":
      return {
        ...state,
        activeEditorState: action.payload.activeEditorState,
        activeComponentInfo:
          action.payload.activeComponentInfo || state.activeComponentInfo,
        lastEditorChangeTime: {
          timeStamp: Date.now(),
          componentInfo:
            action.payload.activeComponentInfo || state.activeComponentInfo,
        },
      };

    case "UPDATE_ACTIVE_COMPONENT":
      return {
        ...state,
        activeComponent: action.payload,
      };

    case "UPDATE_ACTIVE_EDITOR_INFO":
      return {
        ...state,
        activeComponentInfo: action.payload,
        lastEditorChangeTime: {
          timeStamp: Date.now(),
          componentInfo: action.payload,
        },
      };

    case "FORCE_UPDATE_LOCAL_EDITOR_STATE":
      return {
        ...state,
        forceUpdateEditorConfigs: action.payload,
      };

    case "NUKE_ACTIVE_EDITOR":
      return {
        ...state,
        activeEditorState: null,
        activeComponent: null,
        activeComponentInfo: null,
        highlightedContent: null,
        lastEditorChangeTime: null,
        activeClauseOptionValueId: null,
      };

    case "UPDATE_EDITOR_HIGHLIGHT_SELECTION":
      return {
        ...state,
        highlightedContent: action.payload,
      };

    default:
      return state;
  }
};
